<template>
	<div :class="{'has-error': mensagemErro}">
		<label> <span v-if="obrigatorio" class="no-print">*</span> {{ label }}: </label>
		<textarea
			class="form-control"
			:value="value.model"
			@input="emitValue('input', $event.target.value)"
			:rows="tamanho"
			:disabled="disabled"
		></textarea>
		<p class="help-block" v-show="mensagemErro">{{ mensagemErro }}</p>
	</div>
</template>

<script>
import mixinInputModel from './mixinInputModel'
export default {
	mixins: [mixinInputModel],
	props: {
		tamanho: {
			type: Number,
			required: false,
			default: 3
		}
	}
}
</script>
